import React from 'react';
import { services } from '../mockData';

const Marquee = () => {
  const items = [...services.map((s) => s.title), 'Driving Value', 'Adding Solutions'];
  const row = [...items, ...items];

  return (
    <div className="bg-white border-y border-gray-100 py-8 overflow-hidden select-none" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="text-4xl md:text-6xl font-extrabold uppercase tracking-tight text-outline px-6">
              {item}
            </span>
            <span className="w-3 h-3 bg-brand-red rounded-full flex-shrink-0"></span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
